import { PayloadAction } from '@reduxjs/toolkit'
import { getExecutiveMetrics } from '@http/executiveMetricsService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { LoadExecutiveMetricsPayload } from '../types'
import { executiveMetricsFailed, executiveMetricsLoaded, loadExecutiveMetrics } from './executiveMetricsSlice'

const message = (error: Error) => error.message || 'No fue posible cargar las métricas.'

export function* loadHttp(action: PayloadAction<LoadExecutiveMetricsPayload>) {
  const requestKey = action.payload.requestId
  const { cocap } = yield select(selectCredentials)
  try {
    const data = yield call(getExecutiveMetrics, cocap, action.payload)
    yield put(executiveMetricsLoaded({ requestKey, data }))
  } catch (error) {
    yield put(executiveMetricsFailed({ requestKey, message: message(error) }))
  }
}

export default function* executiveMetricsSaga() {
  yield takeLatest(loadExecutiveMetrics.type, loadHttp)
}
